import tmhRequest from '@/config/tmhRequest'

export default {

    searchSkinReportDetail: function (data) {
        return tmhRequest({
            url: '/health/tmh/skinreport/searchskinreportdetail',
            method: 'post',
            params: data,
        })
    },

    searchListSkinReport: function (data) {
        return tmhRequest({
            url: '/health/tmh/skinreport/searchlistskinreport',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/health/skinreport.js